import { service } from '../index.js'

// 优惠券
export const coupon = {
  // 后台：列表
  adminList: (params) => {
    return service.get('/coupon/admin/list', { params })
  },
  // 后台：创建
  adminCreate: (data) => {
    return service.post('/coupon/admin/create', data)
  },
  // 后台：更新
  adminUpdate: (data) => {
    return service.post('/coupon/admin/update', data)
  },
  // 后台：删除
  adminDelete: (data) => {
    return service.post('/coupon/admin/delete', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/coupon.js